import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>


      <footer className="footer-section">
        <div className="bottom-shape">
          <img src="assets/img/footer/bg-bottom.png" alt="shape-img" />
        </div>
        <div className="busket-shape float-bob-x">
          <img src="assets/img/footer/busket.png" alt="shape-img" />
        </div>
        <div className="ball-shape float-bob-y">
          <img src="assets/img/footer/ball.png" alt="shape-img" />
        </div>
        <div className="container">
          <div className="footer-widgets-wrapper">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-8 wow fadeInUp" data-wow-delay=".2s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <a to="index.html">
                      <img src="assets/sa/Sudarshan Academy_logo.png" style={{ height: "100px", width: "100px" }} alt="logo-image" />
                    </a>
                  </div>
                  <div className="widget-content">
                    {/* <p>Kidza is an early childhood education school where all children, typically aged 4 to
                      6, begin their learning journey.</p> */}
                    <ul className="social-icon">
                      <li>
                        <a href="https://www.instagram.com/sudarshanacademy/" target="_blank"><i className="fab fa-instagram" style={{ color: "black" }} /></a>
                      </li>
                      <li>
                        <a href="https://www.facebook.com/p/Sudarshan-Public-Hr-Sec-School-100077597860273/" target="_blank"><i className="fab fa-facebook-f" /></a>
                      </li>
                      <li>
                        <a href="https://youtube.com/@sudarshanpublicschool5741?si=ZClz4KECKXs6aIHD" target="_blank"><i className="fab fa-youtube" /></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".4s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <h3>Quick Links</h3>
                  </div>
                  <div className="widget-content">
                    <ul className="list-area">
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/facility">Facility</Link></li>
                      <li><Link to="/activities">Activities</Link></li>
                      <li><Link to="/about-us">About Us</Link></li>


                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 wow fadeInUp" data-wow-delay=".6s">
                <div className="single-footer-widget">
                  <div className="widget-head">
                    <h3>Links info</h3>
                  </div>
                  <div className="widget-content">
                    <ul className="list-area">
                      <li><Link to="/blog">Our Blog</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>
                      <li><Link to="/director-message">Director Message</Link></li>
                      <li><Link to="/videos">Explore Our Videos</Link></li>


                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".8s">
                <div className="single-footer-widget">
                  <div className="widget-content">
                    <div className="contact-info">
                      <div className="icon">
                        <img src="assets/img/footer/email.svg" alt="icon-image" />
                      </div>
                      <div className="content">
                        <h3>Email us</h3>
                        <p>
                          <a href="mailto:sudarshan312317@gmail.com">sudarshan312317@gmail.com</a>
                        </p>
                      </div>
                    </div>
                    <div className="contact-info">
                      <div className="icon">
                        <img src="assets/img/footer/location.svg" alt="icon-image" />
                      </div>
                      <div className="content">
                        <h3>Location</h3>
                        <p>
                          <a href='https://share.google/KkzqyENBtHYlkwyTz'>Abdul Kalam Azad Ward
                            No.12, Neemi Road, Satna (MP)</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="footer-bottom wow fadeInUp" data-wow-delay=".5s"> <a href='https://www.sphssatna.com/'>2026 © Sudarshan Academy</a> <a href="tel:+91 8982479824"> Designed by Web solution & digital marketing</a></p>
          </div>
        </div>
      </footer>



      {/* <PopUp /> */}
      <WhatsappIcon />

    </>
  )
}

export default Footer